/** @format */

import {
  CarserIcon,
  ContentEditorIcon,
  DownloadIcon,
  ImageEditorIcon,
  ImageTextEditorIcon,
  SaleInfoIcon,
  ServiceInfoIcon,
  VideoEditorIcon
} from 'src/components/icons';

import type { ContentPartType } from 'src/types';

/** Part `type` values match backend `contentParts[].type`. */
export const CONTENT_EDITOR_PART_TYPES: Array<{ type: ContentPartType; Icon: typeof ContentEditorIcon }> = [
  { type: 'content', Icon: ContentEditorIcon },
  { type: 'image', Icon: ImageEditorIcon },
  { type: 'imageText', Icon: ImageTextEditorIcon },
  { type: 'video', Icon: VideoEditorIcon },
  { type: 'salesInformationNo', Icon: SaleInfoIcon },
  { type: 'serviceInformationNo', Icon: ServiceInfoIcon },
  { type: 'documents', Icon: DownloadIcon },
  { type: 'casaNumber', Icon: CarserIcon }
];
